import { render } from "./MedicalView.vue?vue&type=template&id=8e140b6a&scoped=true&ts=true"
import script from "./MedicalView.vue?vue&type=script&lang=ts"
export * from "./MedicalView.vue?vue&type=script&lang=ts"

import "./MedicalView.vue?vue&type=style&index=0&id=8e140b6a&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e140b6a"]])

export default __exports__